import CSVPreviewSection from '../CSVPreviewSection'
import {StaffPerformanceColumnsConfig} from 'constants'
import {ReportGroupingLevel} from '../../../constants'

export default function StaffPerformanceCSVPreviewHeader() {}

StaffPerformanceCSVPreviewHeader.prototype = new CSVPreviewSection();

StaffPerformanceCSVPreviewHeader.prototype.init = function( firstGroupingLevel, secondGroupingLevel, thirdGroupingLevel, columnsStrategy, columnsConfig, numOfGroupingCols )
{
    CSVPreviewSection.prototype.init.call( this );
    this.firstGroupingLevel = firstGroupingLevel;
    this.secondGroupingLevel = secondGroupingLevel;
    this.thirdGroupingLevel = thirdGroupingLevel;
    this.columnsStrategy = columnsStrategy;
    this.columnsConfig = columnsConfig;
    this.numOfGroupingCols = numOfGroupingCols;
    return this;
};

StaffPerformanceCSVPreviewHeader.prototype.hasGroupingRow = function()
{
    return this.columnsConfig === StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITH_SUBTOTALS ||
           this.columnsConfig === StaffPerformanceColumnsConfig.USERS_BY_GROUPS_WITHOUT_SUBTOTALS ||
           this.columnsConfig === StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITH_SUBTOTALS ||
           this.columnsConfig === StaffPerformanceColumnsConfig.USERS_BY_TIME_ZONE_GROUPS_WITHOUT_SUBTOTALS
};

StaffPerformanceCSVPreviewHeader.prototype.addRows = function( tBody )
{
    if( this.hasGroupingRow() )
    {
        let groupingHeaderRow = this.createRow()
        ReportPreviewUtils.addEmptyCells( groupingHeaderRow, this.numOfGroupingCols );
        this.columnsStrategy.addColumnGropingHeaderRowCells( groupingHeaderRow );
        this.addRow( tBody, groupingHeaderRow );
    }

    let mainHeaderRow = this.createRow()
    this.addCell( mainHeaderRow, ReportPreviewUtils.getLevelPreviewName( this.firstGroupingLevel ) );
    if( this.secondGroupingLevel !== ReportGroupingLevel.NONE )
        this.addCell( mainHeaderRow, ReportPreviewUtils.getLevelPreviewName( this.secondGroupingLevel ) );
    if( this.thirdGroupingLevel !== ReportGroupingLevel.NONE )
        this.addCell( mainHeaderRow, ReportPreviewUtils.getLevelPreviewName( this.thirdGroupingLevel ) );
    this.columnsStrategy.addMainHeaderRowCells( mainHeaderRow );
    this.addRow( tBody, mainHeaderRow );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewHeader.js